import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  show: false,
  dialogVisible: false,
  theme: "",
  type: "",
  width:0
}

const mutations = {
  showLoading(state, status = false) {
    state.show = status;
  },
  showDialogVisible(state, res) {
    state.dialogVisible = res.show;
    if (res.form) {
      state.theme = res.form.theme;
      state.type = res.form.type;
    }
  },
  setWidth(state,width){
    state.width = width;
  }
}

export default new Vuex.Store({
  state,
  mutations
});



// WEBPACK FOOTER //
// ./src/vuex/store.js